import React, { useState } from "react";

import {
    LinearProgress,
    OutlinedInput,
} from "@material-ui/core";
import VisibilityIcon from '@material-ui/icons/Visibility';
import {
    Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem,
    TableRow, Table,
    TableHead,
    TableBody,TableContainer,
      Paper,
    TableCell
} from "@material-ui/core";
import TablePagination from '@material-ui/core/TablePagination';
import AddIcon from '@material-ui/icons/Add';
import StudentService from "./Locality/Service/studentService"
import SpecialObservationService from "./Locality/Service/specialObservationService"
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import { Grid, Card, Box, Select, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import { useContext, useEffect } from 'react';
import { useTheme } from "@material-ui/styles";
import {
    ResponsiveContainer,
    ComposedChart,
    AreaChart,
    LineChart,
    Line,
    Area,
    PieChart,
    Pie,
    Cell,
    YAxis,
    XAxis,
} from "recharts";
import mock from "./mock";
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { Typography } from "../../components/Wrappers/Wrappers";
import Dot from "../../components/Sidebar/components/Dot";
import BigStat from "./components/BigStat/BigStat";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import AddClassService from "./Locality/Service/addClassService";
const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#0f3b62ad",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));
export default function Teacher() {
    const tableHeaders = ['Class', 'Date', 'Special Observation', 'Edit', 'Delete', 'Add More'];
    const classes = useStyles();
    const [teacherList, setTeacherList] = useState([]);
    const [classNameList, setClassNameList] = useState([]);
    const [addClassList, setAddClassList] = useState([]);
    const [age, setAge] = React.useState('');
    const [studentList, setStudentList] = useState([]);
    var [error, setError] = useState(null);
    const [teacherIdList, setTeacherIdList] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(1000);
    const [specialObservationList, setSpecialObservationList] = useState([]);
    const [observation, setObservation] = useState({
        studentId: '',
        date: '',
        specialObservation: '',
        classId: '',
    })
    const validationSchema = Yup.object().shape({
        // classId: Yup.string().required('Class Name is required'),
        studentId: Yup.string().required('Student Name is required'),
        date: Yup.string().required('Date is required'),
        specialObservation: Yup.string(),
       
    });
    useEffect(() => {
        // getStudentList();
        getSpecialObservationList();
        getAddClassList();
        return () => {
            setTeacherIdList([]);
            setTeacherList([]);
            setAddClassList([]);
            setStudentList([]);
            setSpecialObservationList([]);
            // setClassNameList([]);
        }
    }, []);
    const getStudentList = (event, obj) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const getSpeList = {  classId:event.target.value};
        StudentService.getAllStudentById(userDetails.schooleId,
            getSpeList
        ).then((res) => {
            const studentDetails = res.map(res => {

                return { _id: res._id, studentName: `${res.firstName} ${res.lastName}`, status: true };
            })
            setStudentList(studentDetails);

        }).catch((err) => {
            // setError(err.message);
        });
    }
    const handleOpen = (status) => {
        if(status){
            setObservation({
                studentId: '',
                date: '',
                specialObservation: '',
        })
        }
     
          setOpen(true);
      };
    const onclick = () => {
        setOpen(true);
    }
    const handleClose = () => {
        setOpen(false);
    };
    const handleChange = (event) => {
        setAge(event.target.value);
    };
    const handleChangePage=(event, newpage) =>{
        setpg(newpage);
    }
    
    const handleChangeRowsPerPage=(event)=> {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }
    const onSubmit = data => {
        console.log(JSON.stringify(data, null, 2));
    };
    const getSpecialObservationList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        SpecialObservationService.getAllSpecialObservation(userDetails.schooleId).then((res) => {
            setSpecialObservationList(res);
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const getAddClassList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
            setAddClassList(res);
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const editSpecialObservation = (observation, status) => {
       
        const obj = JSON.parse(JSON.stringify(observation));
        obj.studentId = observation.studentId ? observation.studentId._id : '';
        // obj.classId = observation.classId ? observation.classId._id : '';
        obj.classId = observation.classId ? observation.classId._id :'';

        getStudentList( { target: { value: obj.classId } },obj);
        getAddClassList({target: { value: obj.superActivityId }}, obj)
        
         setObservation(obj);
        if(status){
           delete obj._id;
        }
        handleOpen(false);
    }
    const deleteSpecialObservation = (observationdelete) => {
        if (observationdelete) {
            SpecialObservationService.deleteSpecialobservation(observationdelete).then((res) => {
                getSpecialObservationList();
            }).catch((err) => {
            });
        }
    };
    const formik = useFormik({
        initialValues: observation,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            const userDetails = JSON.parse(localStorage.getItem("userDetail"));
            values.schooleId = userDetails.schooleId;
            if (observation._id) {
                SpecialObservationService.upadeSpecialobservation(values).then((res) => {
                    handleClose();
                    getSpecialObservationList();
                    resetForm()
                    alert("Special Observation Updated Successfully.");
                }).catch((err) => {
                });
            }
            else {
                SpecialObservationService.creteSpecialobservation(values).then((res) => {
                    getSpecialObservationList();
                    resetForm();
                    handleClose();
                    alert(" Special Observation Added Successfully.");
                    // props.history.push('/app/vendor');
                })
                    .catch((err) => {
                        alert(err.response.data.message)
                    })
            }

        },
    });

    return (

        <>
            <PageTitle title="Special Observation" button={<Button
                variant="contained" onClick={() => handleOpen(true)}
                size="medium"
                color="secondary" style={{ backgroundColor: 'rgb(15 59 98)' }}> Add Observation
            </Button>} />
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                                                <TableContainer component={Paper} style={{ maxHeight: 500 }}>

                        <Table stickyHeader className="mb-0">
                            <TableHead >
                                <TableRow>
                                    {tableHeaders.map(key => (
                                        <StyledTableCell key={key}>{key}</StyledTableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>

                                {(() => {
                                    // Group observations by student so each student's observations stay together
                                    const grouped = new Map();
                                    const list = Array.isArray(specialObservationList) ? specialObservationList : [];

                                    // Sort by student name then date desc (keeps blocks stable)
                                    const sorted = [...list].sort((a, b) => {
                                        const aName = `${a?.studentId?.firstName || ""} ${a?.studentId?.lastName || ""}`.trim().toLowerCase();
                                        const bName = `${b?.studentId?.firstName || ""} ${b?.studentId?.lastName || ""}`.trim().toLowerCase();
                                        if (aName !== bName) return aName.localeCompare(bName);
                                        const aDate = String(a?.date || "");
                                        const bDate = String(b?.date || "");
                                        return bDate.localeCompare(aDate);
                                    });

                                    for (const obs of sorted) {
                                        const sid = obs?.studentId?._id || obs?.studentId || "unknown-student";
                                        const studentName = `${obs?.studentId?.firstName || ""} ${obs?.studentId?.lastName || ""}`.trim() || "—";
                                        const key = String(sid);
                                        if (!grouped.has(key)) grouped.set(key, { key, studentName, rows: [] });
                                        grouped.get(key).rows.push(obs);
                                    }

                                    const groupedArr = Array.from(grouped.values());
                                    const pageGroups = groupedArr.slice(pg * rpg, pg * rpg + rpg);

                                    return pageGroups.flatMap((g) => [
                                        <TableRow key={`student-${g.key}`} style={{ backgroundColor: "#7a7f7a" }}>
                                            <TableCell colSpan={tableHeaders.length} style={{ color: "white", fontWeight: 700 }}>
                                                {g.studentName}
                                            </TableCell>
                                        </TableRow>,
                                        ...g.rows.map((observation) => (
                                            <TableRow key={observation._id}>
                                                <TableCell className="pl-3 fw-normal">
                                                    {observation.classId ? observation.classId.className : ''}
                                                </TableCell>
                                                <TableCell className="pl-3 fw-normal">{observation.date}</TableCell>
                                                <TableCell className="pl-3 fw-normal">{observation.specialObservation}</TableCell>
                                                <TableCell>
                                                    <EditIcon style={{ cursor: 'pointer' }} onClick={() => editSpecialObservation(observation)} />
                                                </TableCell>
                                                <TableCell>
                                                    <DeleteIcon style={{ cursor: 'pointer' }} onClick={() => deleteSpecialObservation(observation)} />
                                                </TableCell>
                                                <TableCell>
                                                    <AddIcon style={{ cursor: 'pointer' }} onClick={() => editSpecialObservation(observation, true)} />
                                                </TableCell>
                                            </TableRow>
                                        )),
                                    ]);
                                })()}
                            </TableBody>
                        </Table>
                        </TableContainer>
                        <TablePagination
                            component="div"
                            rowsPerPageOptions={[1000, 10000, 100000 ]}
                            count={Array.from(new Set((specialObservationList || []).map((o) => String(o?.studentId?._id || o?.studentId || 'unknown')))).length}
                            page={pg}
                            onPageChange={handleChangePage}
                            rowsPerPage={rpg}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Widget>
                </Grid>
            </Grid>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Add Observation</DialogTitle>
                <form onSubmit={formik.handleSubmit} >
                    <DialogContent style= {{ width: 308 }}>
                    <FormControl className={classes.formControl} fullWidth="true"
                                        >
                                            <InputLabel id="demo-simple-select-label">Select Class</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                name="classId"
                                                label="selectClass"
                                                autoFocus
                                                value={formik.values.classId}
                                                onChange={e => { formik.handleChange(e); getStudentList(e) }}
                                                // onChange={formik.handleChange}
                                                
                                                error={formik.touched.classId && Boolean(formik.errors.classId)}
                                                helperText={formik.touched.classId && formik.errors.classId}
                                            >
                                                <MenuItem value="">
                                                    <em>None</em>
                                                </MenuItem>

                                                {addClassList.map(({ _id, className }) => (
                                    <MenuItem key={_id} value={_id}>{className}
                                        
                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        <FormControl variant="standard" fullWidth>
                            <InputLabel id="studentName">Student Name</InputLabel>
                            <Select
                                 
                                labelId="studentName"
                                id="studentName"
                                label="Student Name"
                                name="studentId"
                                value={formik.values.studentId}
                                // onChange={e => {
                                //     formik.handleChange(e);
                                //     getStudentList(e.target.value)
                                // }}
                                onChange={formik.handleChange}
                                error={formik.touched.studentId && Boolean(formik.errors.studentId)}
                                helperText={formik.touched.studentId && formik.errors.studentId}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {studentList.map(({ index, _id, studentName }) => (
                                    <MenuItem key={index} value={_id}>{studentName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>



                        <TextField InputProps={{ style: { width: 250 } }}
                                            id="date"
                                            name="date"
                                            label="Select Date"
                                            type="date"
                                            value={formik.values.date}
                                            onChange={formik.handleChange}
                                            error={formik.touched.date && Boolean(formik.errors.date)}
                                            helperText={formik.touched.date && formik.errors.date}
                                            className={classes.textField}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />       
                                        <TextField
                            InputProps={{ style: { width: 258} }}
                            
                            margin="dense"
                            id="specialObservation"
                            name="specialObservation"
                            label="Special Observation"
                            type="text"
                            variant="standard"
                            value={formik.values.specialObservation}
                            onChange={formik.handleChange}
                            error={formik.touched.specialObservation && Boolean(formik.errors.specialObservation)}
                            helperText={formik.touched.specialObservation && formik.errors.specialObservation}
                        />
              
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button type="submit">Add</Button>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    );
}


